import platformType from "@/utils/platformType";

export default {
  dispatch(methodName, argument = '') {
    return new Promise((resolve, reject) => {
      try {
        if (platformType.isIos()) {
          window.webkit.messageHandlers[methodName].postMessage(argument);
        } else if (platformType.isAndroid()) {
          if (argument.length > 0) {
            android[methodName](argument);
          } else {
            android[methodName]();
          }
        }

        resolve()
      } catch (e) {
        reject(e)
      }
    })
  }
}
